import { useHistory } from "react-router-dom";

import PageTabs from "../../atoms/PageTabs";

import usePortfoliosContext from "../../../helpers/contexts/offsetsPortfolios";

const PortfoliosOptionsBar = () => {
  const history = useHistory();
  const {
    portfolios,
    portfoliosLoading,
    selectedPortfolio,
    displayPageUrl,
    onPortfolioSelect
  } = usePortfoliosContext();

  const { id: selectedPortfolioId } = selectedPortfolio || {};

  if (portfoliosLoading) {
    return <></>;
  }

  const tabs = portfolios.map(({ id, name }) => ({ value: id, label: name }));

  const handleChange = (_, id) => {
    if (onPortfolioSelect) {
      return onPortfolioSelect(id);
    }
    return history.push(`${displayPageUrl}/${id}`);
  };

  return (
    <PageTabs tabs={tabs} value={selectedPortfolioId} onChange={handleChange} />
  );
};
export default PortfoliosOptionsBar;
